import { morph, MORPH_OPTIONS } from '@theme/morph';

/**
 * Linked product picker — navegação entre produtos relacionados.
 * NÃO usa <variant-picker> (interferia no morph de variantes).
 *
 * Morph de <main> sem herdar data-current-checked / pills do produto anterior.
 * A seleção visual das variantes usa fundo simples (:checked), sem pill animada.
 */
class LinkedProductPicker extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
    this.#abortController?.abort();
  }

  /**
   * @param {Event} event
   */
  #onChange = (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const selectedOption =
      event.target instanceof HTMLSelectElement
        ? event.target.options[event.target.selectedIndex]
        : event.target;

    if (!selectedOption || !(selectedOption instanceof HTMLElement)) return;

    const newUrl = selectedOption.dataset.connectedProductUrl;
    if (!newUrl) return;

    const currentPath = this.dataset.productUrl?.split('?')[0] || '';
    if (newUrl === currentPath) return;

    const destination = new URL(newUrl, window.location.origin);
    destination.search = '';

    this.#navigate(destination);
  };

  /**
   * @param {URL} destination
   */
  #navigate(destination) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    history.replaceState({}, '', destination.pathname);

    fetch(destination.pathname, { signal: this.#abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const main = document.querySelector('main');
        const newMain = html.querySelector('main');

        if (main && newMain) {
          morph(main, newMain, {
            childrenOnly: true,
            reject: MORPH_OPTIONS.reject,
            onAfterUpdate: MORPH_OPTIONS.onAfterUpdate,
            onBeforeUpdate(oldNode, newNode) {
              if (!(oldNode instanceof Element) || !(newNode instanceof Element)) return;

              const attributes = ['product-grid-view', 'cart-summary-sticky'];
              for (const attribute of attributes) {
                const oldValue = oldNode.getAttribute(attribute);
                const newValue = newNode.getAttribute(attribute);
                if (oldValue && oldValue !== newValue) {
                  newNode.setAttribute(attribute, oldValue);
                }
              }
            },
          });
          return;
        }

        window.location.assign(destination.pathname);
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        window.location.assign(destination.pathname);
      });
  }
}

if (!customElements.get('linked-product-picker')) {
  customElements.define('linked-product-picker', LinkedProductPicker);
}
